import Vec2 from 'gl-vec2';
import Vec3 from 'gl-vec3';

export const getLerpFactor = (val, dt = 1) => (1 - Math.pow(1 - val, dt));

export const lerp = (from, to, val, dt = 1) => from + (to - from) * getLerpFactor(val, dt);
export const lerpAngle = (from, to, val, dt = 1) => {
  if (to - from > Math.PI) from += 2 * Math.PI;
  if (to - from < -Math.PI) from -= 2 * Math.PI;
  return lerp(from, to, val, dt);
};
export const lerpVec2 = (vec2, to, val, dt = 1) => Vec2.lerp(vec2, vec2, to, getLerpFactor(val, dt));
export const lerpVec3 = (vec3, to, val, dt = 1) => Vec3.lerp(vec3, vec3, to, getLerpFactor(val, dt));